<template>
  <div
    v-if="visible"
    class="health-float-ball"
    :style="ballStyle"
    @touchstart="onTouchStart"
    @touchmove="onTouchMove"
    @touchend="onTouchEnd"
    @click="handleClick"
  >
    <div class="ball-content">
      <div class="ball-icon">
        <img src="@/assets/push/push-fei-tip.png" alt="肺健康" />
      </div>
      <div class="ball-text">肺健康</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthFloatBall',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detailUrl: {
      type: String,
      default: 'https://video.pacsonline.cn/value/20251216.jpg'
    }
  },
  data() {
    return {
      position: {
        x: 0,
        y: 0
      },
      dragging: false,
      startPos: {
        x: 0,
        y: 0
      },
      moveDistance: 0
    };
  },
  computed: {
    ballStyle() {
      return {
        right: `${this.position.x}px`,
        bottom: `${this.position.y}px`,
        zIndex: 99999
      };
    }
  },
  mounted() {
    // 初始化位置
    this.initPosition();
  },
  methods: {
    initPosition() {
      // 默认位置：右下角
      this.position = {
        x: 20,
        y: 100
      };
    },
    onTouchStart(e) {
      this.dragging = true;
      this.moveDistance = 0;
      const touch = e.touches[0];
      this.startPos = {
        x: touch.clientX,
        y: touch.clientY
      };
    },
    onTouchMove(e) {
      if (!this.dragging) return;

      e.preventDefault();
      const touch = e.touches[0];
      const deltaX = this.startPos.x - touch.clientX;
      const deltaY = touch.clientY - this.startPos.y;

      // 计算移动距离
      this.moveDistance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

      // 更新位置
      this.position.x += deltaX;
      this.position.y += deltaY;

      // 限制边界
      const maxX = window.innerWidth - 80;
      const maxY = window.innerHeight - 80;

      this.position.x = Math.max(0, Math.min(maxX, this.position.x));
      this.position.y = Math.max(0, Math.min(maxY, this.position.y));

      this.startPos = {
        x: touch.clientX,
        y: touch.clientY
      };
    },
    onTouchEnd() {
      this.dragging = false;
    },
    handleClick() {
      // 如果移动距离小于5px，认为是点击，否则是拖动
      if (this.moveDistance < 5) {
        this.$emit('click');
      }
    }
  }
};
</script>

<style scoped>
.health-float-ball {
  position: fixed;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); */
  cursor: pointer;
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
  user-select: none;
  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  overflow: hidden;
}

.health-float-ball:active {
  transform: scale(0.95);
}

.ball-content {
  position: relative;
  width: 100%;
  height: 100%;
}

.ball-icon {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.ball-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ball-text {
  position: absolute;
  bottom: 14px;
  left: 0;
  right: 0;
  font-size: 10px;
  color: #fff;
  font-weight: 500;
  text-align: center;
  line-height: 1.2;
  white-space: nowrap;
  z-index: 1;
}
</style>
